import { render, staticRenderFns } from "./AdminOverview.vue?vue&type=template&id=13de4acc&scoped=true&"
import script from "./AdminOverview.vue?vue&type=script&lang=ts&"
export * from "./AdminOverview.vue?vue&type=script&lang=ts&"
import style0 from "./AdminOverview.vue?vue&type=style&index=0&id=13de4acc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13de4acc",
  null
  
)

export default component.exports